"use client";

import { ReactNode } from "react";
import { cn } from "utils";
import { useIsPc, useSwipeTabs } from "@/src/hooks";
import { useNewsPrimaryTabs, type NewsThemeGroup } from "./useNewsPrimaryTabs";

type NewsPrimarySwipePanelProps = {
  groups: NewsThemeGroup[];
  children: ReactNode;
  className?: string;
};

/**
 * News 页面级一级 tab 手势切换容器。
 *
 * 注意：手势绑定在“内容面板区”（children）而不是 tab 头部，
 * 避免一级/二级 tab 的横向滚动与页面级手势互相干扰。
 */
export const NewsPrimarySwipePanel = ({
  groups,
  children,
  className,
}: NewsPrimarySwipePanelProps) => {
  const [isPC] = useIsPc();
  const { tabs, activePrimaryTabKey, onPrimaryTabChange } = useNewsPrimaryTabs({
    groups,
  });

  const { bind: swipeBind, transitionClassName } = useSwipeTabs<string>({
    tabs: tabs.map((item) => ({ id: item.key })),
    activeId: activePrimaryTabKey,
    onChange: onPrimaryTabChange,
    enabled: !isPC,
    transition: {
      enabled: !isPC,
      mode: "route",
      // News 一级 tab 页面级手势动画方向存储 key（页面唯一，避免串读）
      storageKey: "newsPrimarySwipeDirection",
    },
  });

  return (
    <div {...swipeBind} className={cn("min-h-0 flex-1", className)}>
      <div className={cn("min-h-0 flex-1", transitionClassName)}>
        {children}
      </div>
    </div>
  );
};
